angular.module('dentalLinks')
  .filter('invitedDestination', function () {
    // DCL-680: a referral to someone not yet on DCL waits on their invitation
    // (dest_provider_invited set, no dest_provider_id or dest_practice_id). For
    // such a referral, the line under the invitee's name reads:
    //   {expired: false, label: '-- pending registration (ann@example.com) --'} while the invitation is open
    //   {expired: true,  label: 'ann@example.com'}  once the nightly job expired it
    //                                               (removal_reason; a deleted or
    //                                               unsubscribed invitation is not
    //                                               shown as expired)
    // and null for any other referral. A referral switched from a practice to an
    // invitation can keep the practice, and then it is in that practice's inbox.
    // Display only: the referral itself is not expired (expired_at), so it can
    // still be updated and stays out of the archive.
    return function (referral) {
      var invitation = referral && referral.dest_provider_invited;
      if (!invitation || referral.dest_provider_id || referral.dest_practice_id) {
        return null;
      }

      if (invitation.removed_at && invitation.removal_reason === 'expired') {
        return {expired: true, label: invitation.email || ''};
      }

      return {
        expired: false,
        label: invitation.email ? '-- pending registration (' + invitation.email + ') --' : '-- pending registration --'
      };
    };
  });
